import { useState } from 'react';
import { deleteWorkshopType } from '../../apis/workshopTypeApi';

export const useDeleteWorkshopType = () => {
    const [loading, setLoading] = useState(false);

    const deleteWorkshopTypeData = async (id: number, refetch: () => void): Promise<boolean> => {
        setLoading(true);
        try {
            await deleteWorkshopType(id);
            refetch();
            return true;
        } catch (error) {
            console.error('Failed to delete workshop type:', error);
            return false;
        } finally {
            setLoading(false);
        }
    };

    return { deleteWorkshopTypeData, loading };
};
